/**
 * Created by Kevin on 2016-02-24.
 */
angular.module('flipto.core.enums')
    .constant('confirmationDisplayTypes', [
        { id: "1", name: 'Integrated - basic sharing component attached to an element ' },
        { id: "2", name: 'Fullscreen - basic sharing component overlaid on page' },
        { id: "3", name: 'Immersive - a complete personalized guest experience (New)' }
    ]);